import {INVOICE_STATUS} from "../config/constants";


export const getStatusLabel = status => {
    switch (status) {
        case INVOICE_STATUS.DRAFT:
            return "En cours";
        case INVOICE_STATUS.SENT:
            return "Envoyée";
        case INVOICE_STATUS.PAID:
            return "Payée";
        case INVOICE_STATUS.OVERDUE:
            return "Échue";
        default:
            return "En cours";
    }
};

export const getStatusClass = status => {
    switch (status) {
        case INVOICE_STATUS.DRAFT:
            return "warning";
        case INVOICE_STATUS.SENT:
            return "info";
        case INVOICE_STATUS.PAID:
            return "success";
        case INVOICE_STATUS.OVERDUE:
            return "error";
        default:
            return "warning";
    }
};

export const calculateTotal = (price, quantity) => (price || 0) * (quantity || 1);
